
<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="800px"
  transition="dialog-transition">
    <v-card>
      <v-card-title>
        <span class="headline">Editando contatos do cliente</span>
      </v-card-title>
      <v-card-text>
        <v-col cols='12'>
          <template v-for="(con, index) in new_client.contacts_attributes">
            <v-container grid-list-lg :key="`con-${index}`">
              <ContactForm v-on="$listeners" :ref='`contact${index}`' includes_employee :contact="con"></ContactForm>
              <v-divider></v-divider>
            </v-container>
          </template>
          <v-btn icon text color="error" :disabled="newContact == 0"
            @click="newContact -= 1"><v-icon>mdi-minus</v-icon></v-btn>
          <v-btn icon text color="primary" :disabled="new_client.contacts_attributes.length == 5"
            @click="newContact += 1"><v-icon>mdi-plus</v-icon></v-btn>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn cancel @click="closeDialog"></f-btn>
        <f-btn save @click="emitUpdate"></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ClientEditContactsDialog',
  props: {
    change_dialog:{
      type: Boolean,
      default: false,
    },
  },
  components:{
    ContactForm:() => import("@/_backoffice/_registrations/components/shared/forms/ContactForm.vue"),
  },
  data() {
    return {
      dialog: false,
      new_client:{
        contacts_attributes: [],
      },
      newContact: 0,
    }
  },
  methods: {
    emitUpdate(){
      let valid = []
      for(let index = 0 ; index < this.new_client.contacts_attributes.length; index++ ){
        if(this.new_client.contacts_attributes[index].email){
          valid.push(this.$refs[`contact${index}`][0].validate())
        }
      }
      
      if(!valid.includes(false)){
        this.$emit('update', {new_client: this.new_client, model: 'contacts'})
      }
    },
    closeDialog(){
      this.$emit('close')
    }
  },
  computed:{
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },
    dialog(nv, old) {
      if (nv) {
        var contacts = this.oneClient?.data?.attributes?.contacts
        this.new_client = {
          id: this.oneClient?.data.id,
          contacts_attributes: [],
        }
        if (contacts != null) {
          contacts.data.forEach((contact, index) => {
            var { id, name, position, email, celphone, telephone } = contact.attributes
            var obj = {
              id: id,
              name: name,
              position: position,
              email: email,
              celphone: celphone,
              telephone: telephone
            }
            this.new_client.contacts_attributes.push(obj)
          });
        } else {
          var obj = {
            name: null,
            position: null,
            email: null,
            celphone: null,
            telephone: null
          }
          this.new_client.contacts_attributes.push(obj)
        }
      } else if (!nv) {
        this.new_client = {
          contacts_attributes: [],
        }
      }
    },
    newContact(nv, ov) {
      var obj = {
        name: null,
        position: null,
        email: null,
        celphone: null,
        telephone: null
      }
      if (nv > ov) {
        this.new_client.contacts_attributes.push(obj)
      } else if (nv < ov) {
        this.new_client.contacts_attributes.pop()
      }
    },

  }
}
</script>
